export default ({ eventBus, eventDefinitions, context }) => {
  eventBus.$on(eventDefinitions.SEARCH.QUERY, ({ query, location }) => {
    if (query && query.length >= context.app.$contentSettings.events.dataLayerBasic.searchQuery.minimumCharacters) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'search',
        search_term: query,
      })
    }
  })
}
